<template lang="pug">
.rating-card
  .rating-card__class
    i.icon(:class="nameIcon")

  .rating-card__info
    .rating-card__name {{ nickname }}
    .rating-card__server {{ serverName }}
</template>

<script>
export default {
  name: "RatingCard",
  props: {
    nickname: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    serverName: {
      type: String,
      default: "",
    },
  },
  computed: {
    nameIcon() {
      return `icon-class-${this.className}`
    },
  },
};
</script>
